export default "__VITE_ASSET__a26bd745__"